import React from "react";
import {Card, CardContent, Grid, Typography} from "@mui/material";
import {sprintf} from "sprintf-js";
import {ChecklistField, LeadChecklistField} from "../formFields/ChecklistField";
import ChecklistItemDefault from "../defaults/ChecklistItemDefault";

const [section, name, title] = [8, "HealthAndSafety", "General Health & Safety"];

const HealthAndSafetyDefaults = () => {
    return {
        "8": {
            "1": ChecklistItemDefault,
            "2": ChecklistItemDefault,
            "3": ChecklistItemDefault,
            "4": ChecklistItemDefault,
            "5": ChecklistItemDefault,
            "6": ChecklistItemDefault,
            "7": ChecklistItemDefault,
            "8": ChecklistItemDefault,
            "9": ChecklistItemDefault,
            "10": ChecklistItemDefault,
            "11": ChecklistItemDefault
        }
    };
}

const HealthAndSafety = () => {
    const relPath = name;
    return (
        <>
            <Card>
                <CardContent>
                    <Typography variant={"h6"} gutterBottom>
                        {sprintf("%d. %s", section, title)}
                    </Typography>
                    <Grid container spacing={3}>
                        <ChecklistField
                            path={sprintf("%s.%s", relPath, "access")}
                            rank={"8.1"}
                            room={name}
                            desc={"Access to Unit"}
                            section={section}
                        />
                    </Grid>
                    <Grid container spacing={3}>
                        <ChecklistField
                            path={sprintf("%s.%s", relPath, "fireExits")}
                            rank={"8.2"}
                            room={name}
                            desc={"Fire Exits"}
                            section={section}
                        />
                    </Grid>
                    <Grid container spacing={3}>
                        <ChecklistField
                            path={sprintf("%s.%s", relPath, "infestationFree")}
                            rank={"8.3"}
                            room={name}
                            desc={"Free of Evidence of Infestation"}
                            section={section}
                        />
                    </Grid>
                    <Grid container spacing={3}>
                        <ChecklistField
                            path={sprintf("%s.%s", relPath, "garbageFree")}
                            rank={"8.4"}
                            room={name}
                            desc={"Free of Garbage & Debris"}
                            section={section}
                        />
                    </Grid>
                    <Grid container spacing={3}>
                        <ChecklistField
                            path={sprintf("%s.%s", relPath, "disposal")}
                            rank={"8.5"}
                            room={name}
                            desc={"Refuse Disposal"}
                            section={section}
                        />
                    </Grid>
                    <Grid container spacing={3}>
                        <ChecklistField
                            path={sprintf("%s.%s", relPath, "stairsHalls")}
                            rank={"8.6"}
                            room={name}
                            desc={"Interior Stairs & Common Halls"}
                            section={section}
                        />
                    </Grid>
                    <Grid container spacing={3}>
                        <ChecklistField
                            path={sprintf("%s.%s", relPath, "interiorHazardFree")}
                            rank={"8.7"}
                            room={name}
                            desc={"Free of Other Interior Hazards"}
                            section={section}
                        />
                    </Grid>
                    <Grid container spacing={3}>
                        <ChecklistField
                            path={sprintf("%s.%s", relPath, "elevators")}
                            rank={"8.8"}
                            room={name}
                            desc={"Elevators"}
                            section={section}
                        />
                    </Grid>
                    <Grid container spacing={3}>
                        <ChecklistField
                            path={sprintf("%s.%s", relPath, "airQuality")}
                            rank={"8.9"}
                            room={name}
                            desc={"Interior Air Quality"}
                            section={section}
                        />
                    </Grid>
                    <Grid container spacing={3}>
                        <ChecklistField
                            path={sprintf("%s.%s", relPath, "siteConditions")}
                            rank={"8.10"}
                            room={name}
                            desc={"Site & Neighborhood Conditions"}
                            section={section}
                        />
                    </Grid>
                    <Grid container spacing={3}>
                        <LeadChecklistField
                            path={sprintf("%s.%s", relPath, "leadCertification")}
                            rank={"8.11"}
                            room={name}
                            desc={"Lead-Based Paint: Owner's Certification"}
                            section={section}
                        />
                    </Grid>
                </CardContent>
            </Card>
        </>
    );
}

export default HealthAndSafety;
export {HealthAndSafetyDefaults};